// extracted by mini-css-extract-plugin
module.exports = {"thumbLabel":"style-module__thumbLabel___nRvi-","right":"style-module__right___s0jLA","value":"style-module__value___wh9te"};